/**
 * Copyright (c) Matthieu POIGNANT
 * matthieu@highlight.pro
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */
import Interface from '../../interface';
import Theme from "../../Theme";

const PopinStyled = Interface.styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  right: -200%;
  transition: all 0.3s;
  visibility: hidden;
  background: ${(props) => props.theme.popin.background};
  border: ${(props) => `${props.theme.popin.border.width} ${props.theme.popin.border.style} ${props.theme.popin.border.color}`};
  border-radius: ${(props) => `${props.theme.radius}px`};
  padding: ${(props) => props.theme.popin.padding};
  box-sizing: border-box;
  overflow: hidden;
`;
PopinStyled.defaultProps = {
    theme: Theme,
};

const e = Interface.createElement;

const Popin = ({handlePrevClick}) =>
    e(PopinStyled, {
        className: `ziiircom-messenger-popin`,
        onClick: handlePrevClick,
    });

export default Popin;
